import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homeone-banner',
  templateUrl: './homeone-banner.component.html',
  styleUrls: ['./homeone-banner.component.scss']
})
export class HomeoneBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
